// extracted by mini-css-extract-plugin
export default {"box":"job-contact-person-section_box__Z28Si","image":"job-contact-person-section_image__h4ezo","imageWrapper":"job-contact-person-section_imageWrapper__SDgWV"};